:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pos-relative{position:relative;}
:root ._width-128px{width:128px;}
:root ._cur-pointer{cursor:pointer;}
:root ._pos-absolute{position:absolute;}
:root ._t--6px{top:-6px;}
:root ._r--6px{right:-6px;}
:root ._z-10{z-index:10;}
:root ._width-26px{width:26px;}
:root ._height-26px{height:26px;}
:root ._btlr-13px{border-top-left-radius:13px;}
:root ._btrr-13px{border-top-right-radius:13px;}
:root ._bbrr-13px{border-bottom-right-radius:13px;}
:root ._bblr-13px{border-bottom-left-radius:13px;}
:root ._bg-pressablePr1521563410{background-color:var(--pressablePrimaryBackground);}
:root ._justify-center{justify-content:center;}
:root ._items-center{align-items:center;}
:root ._pr-t-space-lar102228{padding-right:var(--t-space-larger);}
:root ._pl-t-space-lar102228{padding-left:var(--t-space-larger);}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}